import React from 'react'
import { messages } from './messages'
import './styles.scss'

export const FinancingUxFeedbackModalFormTitle = () => {
  return <h4 className="financingUxFeedbackModalFormTitle">{messages.title}</h4>
}
